import initLoggedPage from './logged/logged';

export default async function loggedPage() {
  await initLoggedPage();
}
